import { useAppSelector } from '@/shared/hooks-tmp/reduxToolkitHooks';
import { Dialog, DialogTitle } from '../../../ui-tmp';
import { Actions, CancelButton, Content, SubmitButton, Title } from './styled';
import { useTranslatedVideoFeedbackForm } from './hooks/useTranslatedVideoFeedbackForm';
import { CheckboxList } from './components/CheckboxList';
import { Feedback } from './components/Feedback';

type TTranslatedVideoFeedbackModalProps = {
  rating?: number;
  onClose: () => void;
  resetRating?: () => void;
  onSubmitFeedback?: () => void;
};

export const TranslatedVideoFeedbackModal = ({
  rating,
  onClose,
  resetRating,
  onSubmitFeedback,
}: TTranslatedVideoFeedbackModalProps) => {
  const { isLoading, isFormValid, control, onCancel, onSubmit } = useTranslatedVideoFeedbackForm({
    rating,
    onClose,
    resetRating,
    onSubmitFeedback,
  });

  const { project } = useAppSelector((state) => state.project);

  return (
    <Dialog open onClose={onCancel} size="sm" scroll="body">
      <DialogTitle onClose={onCancel} buttonsDisabled={isLoading} renderTitle={() => <Title>What went wrong?</Title>} />

      <Content isDisabled={isLoading}>
        <CheckboxList control={control} isRaskTtsUsed={project?.used_rask_tts} />
        <Feedback control={control} />
      </Content>

      <Actions>
        <CancelButton onClick={onCancel} disabled={isLoading}>
          Cancel
        </CancelButton>

        <SubmitButton onClick={onSubmit} disabled={!isFormValid || isLoading} isLoading={isLoading}>
          {isLoading ? 'Submitting...' : 'Submit'}
        </SubmitButton>
      </Actions>
    </Dialog>
  );
};
